import React from 'react'
import { Builder } from '@builder.io/react'

type StyledTextProps = {
  copy: string;
}

export const StyledText = ( props: StyledTextProps ): JSX.Element => {

  return (
    <div
      className="[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:p-2 [&_a]:a [&_li]:ml-4 [&_p]:mb-2"
      dangerouslySetInnerHTML={{
        __html: props.copy
      }}
    />
  )
}

Builder.registerComponent( StyledText, {
  name: `StyledText`,
  inputs: [
    {
      name: `copy`,
      type: `richText`,
      defaultValue: `Enter text here...`,
      required: true
    }
  ]
})

export default StyledText